export const clamp = (v: number, a: number, b: number): number => (v < a ? a : v > b ? b : v);

/** Compact human-readable number. Exponential only where a decimal would be absurd. */
export function fmtNum(v: number | null | undefined): string {
  if (v == null || !isFinite(v)) return '—';
  if (Math.abs(v) >= 10000 || (Math.abs(v) < 0.001 && v !== 0)) return v.toExponential(2);
  return String(Number(v.toFixed(Math.abs(v) < 10 ? 4 : 1)));
}

/**
 * A spinner step sized to the range in view. `step="any"` makes browsers default to 1,
 * which is useless for an index spanning -0.1 to 0.9 and too fine for raw DN in the
 * thousands. Rounded to a 1/2/5 decade so the values stay tidy as you click.
 */
export function stepFor(lo: number, hi: number): number {
  const span = Math.abs(hi - lo);
  if (!Number.isFinite(span) || span === 0) return 0.01;
  const raw = span / 100;
  const decade = Math.pow(10, Math.floor(Math.log10(raw)));
  const n = raw / decade;
  return (n < 1.5 ? 1 : n < 3.5 ? 2 : 5) * decade;
}

/** Round to a step, so a spinner click does not accumulate float dust. */
export const snap = (v: number, step: number): number =>
  +(Math.round(v / step) * step).toPrecision(12);
